export default "__VITE_ASSET__C96cLmTr__"